import { Injectable } from '@angular/core';
import { Logger } from 'projects/common/src/app/classes';
import { IParameterConfig } from '../interfaces';

/**
 * Define métodos para obtener parámetros para el manejo de las vistas del sistema
 */
@Injectable({
  providedIn: 'root'
})
export class ModuleConfigService<T> extends Logger implements IParameterConfig<T> {

  protected config: T;

  constructor() {
    super();
  }

  public getConfig(): T {
    return this.config;
  }

  // TODO evaluar donde debe ir este metodo
  /**
   * Retorna un arreglo con los nombres de los parámetros que son requeridos
   * para el funcionamiento del modulo dado en el argumento.
   * Si la configuración no existe retorna null.
   * @param moduleName nombre del módulo del cual se requiere obtener los
   * parámetros necesarios para su funcionamiento
   */
  public requiredParameterForModule(moduleName: string): string[] {
    return null;
  }

}
